/**
 * Throttle calls to a function.
 * @private
 *
 * @param {Function} fn The function to call
 * @param {number} timeout The time to throttle calls
 * @returns {Function} The throttled function
 */
var throttle = function throttle(fn, timeout) {
  var isCalled = false;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    /* istanbul ignore if */
    if (isCalled) {
      return;
    }
    isCalled = true;
    setTimeout(function () {
      fn.apply(void 0, args);
      isCalled = false;
    }, timeout);
  };
};

export { throttle };
